export const PLAYER_FILTER_ALL = 0
export const PLAYER_FILTER_PAYING = 1
export const PLAYER_FILTER_NON_PAYING = 2

export const EXPORT_FORMAT_EMAILS_ONLY = 0
export const EXPORT_FORMAT_EMAILS_WITH_PAYMENTS = 1

export const GROUPING_ALL_IN_ONE = 0
export const GROUPING_BY_GAME = 1

export const EXPORT_STATUS_PENDING = 0
export const EXPORT_STATUS_RUNNING = 1
export const EXPORT_STATUS_DONE = 2
export const EXPORT_STATUS_FAILED = 3

export type PlayerFilter =
  | typeof PLAYER_FILTER_ALL
  | typeof PLAYER_FILTER_PAYING
  | typeof PLAYER_FILTER_NON_PAYING

export type ExportFormat =
  | typeof EXPORT_FORMAT_EMAILS_ONLY
  | typeof EXPORT_FORMAT_EMAILS_WITH_PAYMENTS

export type Grouping = typeof GROUPING_ALL_IN_ONE | typeof GROUPING_BY_GAME

export type ExportStatus =
  | typeof EXPORT_STATUS_PENDING
  | typeof EXPORT_STATUS_RUNNING
  | typeof EXPORT_STATUS_DONE
  | typeof EXPORT_STATUS_FAILED

export const PLAYER_FILTER_LABELS: Record<PlayerFilter, string> = {
  [PLAYER_FILTER_ALL]: 'Все',
  [PLAYER_FILTER_PAYING]: 'Платящие',
  [PLAYER_FILTER_NON_PAYING]: 'Не платящие',
}

export const EXPORT_FORMAT_LABELS: Record<ExportFormat, string> = {
  [EXPORT_FORMAT_EMAILS_ONLY]: 'Только email',
  [EXPORT_FORMAT_EMAILS_WITH_PAYMENTS]: 'Email с суммой платежей за все время',
}

export const GROUPING_LABELS: Record<Grouping, string> = {
  [GROUPING_ALL_IN_ONE]: 'Все в одном',
  [GROUPING_BY_GAME]: 'Каждая игра отдельно',
}

export const EXPORT_STATUS_LABELS: Record<ExportStatus, string> = {
  [EXPORT_STATUS_PENDING]: 'В очереди',
  [EXPORT_STATUS_RUNNING]: 'В процессе',
  [EXPORT_STATUS_DONE]: 'Готово',
  [EXPORT_STATUS_FAILED]: 'Ошибка',
}
